import {Outlet} from "react-router"


const Attributes = () => {
  return <div>
     <Outlet>attributes available / view</Outlet>
  </div>
}
export default Attributes